module.exports = __webpack_public_path__ + "assets/img/headerLogo.bf086ce.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/headerLogo.png
// module id = 334
// module chunks = 5